export const returnFormDocUrl = 'https://media.fh.by/fh-public/docs/forma_vozvrata.docx';

export const shopsIds = {
	10: true,
	3: true,
	14: true,
	18: true,
	19: true,
	11: true,
	8: true,
	12: true,
	25: true,
	16: true,
	13: true,
};
